<template>
  <ErrorLogViewer />
</template>

<script>
import ErrorLogViewer from '@/components/ErrorLogViewer.vue'

export default {
  name: 'AdminErrorLogs',
  components: {
    ErrorLogViewer
  }
}
</script>
